import React, { useEffect } from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import { ArrowLeft, Calendar, User, Clock } from 'lucide-react';
import { blogPosts } from '../data/blogPosts';
import { useLanguage } from '../contexts/LanguageContext';
import '../styles/Blog.css';

const BlogPost = () => {
  const { slug } = useParams();
  const { t } = useLanguage();
  const post = blogPosts.find((p) => p.slug === slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!post) return <Navigate to="/blog" replace />;

  const related = blogPosts.filter((p) => p.slug !== slug).slice(0, 3);

  return (
    <div className="blog-post-page" data-testid="blog-post-page">
      {/* Hero with cover image */}
      <section
        className="blog-post-hero"
        style={{ backgroundImage: `linear-gradient(135deg, rgba(13,76,111,0.65) 0%, rgba(27,94,63,0.65) 100%), url(${post.image})` }}
      >
        <div className="container">
          <div className="blog-post-hero-content">
            <Link to="/blog" className="blog-post-back" data-testid="blog-post-back">
              <ArrowLeft size={18} /> {t('blog.back')}
            </Link>
            <span className="blog-post-category">{post.category}</span>
            <h1 className="display-large blog-post-h1">{post.title}</h1>
            <div className="blog-post-meta-row">
              <span><User size={16} /> {post.author}</span>
              <span><Calendar size={16} /> {new Date(post.date).toLocaleDateString()}</span>
              <span><Clock size={16} /> {post.readTime}</span>
            </div>
          </div>
        </div>
      </section>

      {/* Article body */}
      <article className="blog-post-article">
        <div className="container">
          <div className="blog-post-body" dangerouslySetInnerHTML={{ __html: post.content }} />

          <div className="blog-post-cta">
            <p>{t('home.contactLead')}</p>
            <Link to="/custom-trip" className="btn-primary" data-testid="blog-post-cta-plan">
              {t('home.ctaCustomize')}
            </Link>
          </div>
        </div>
      </article>

      {/* Related posts */}
      {related.length > 0 && (
        <section className="blog-related-section">
          <div className="container">
            <h2 className="heading-2">{t('home.blogTitle')}</h2>
            <div className="blog-related-grid">
              {related.map((p) => (
                <Link key={p.slug} to={`/blog/${p.slug}`} className="blog-card" data-testid={`related-blog-${p.slug}`}>
                  <img src={p.image} alt={p.title} className="blog-image" />
                  <div className="blog-content">
                    <h3 className="blog-title">{p.title}</h3>
                    <p className="blog-description">{p.excerpt}</p>
                    <span className="blog-link">{t('home.blogReadMore')}</span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      )}
    </div>
  );
};

export default BlogPost;
